import { createSelector } from 'reselect'

const nameFolderViewSelector = createSelector(
	[state => state.libraries],
	libraries => ({
		folderUID: libraries.name_folder_modal.folderUID,
		value: libraries.name_folder_modal.value,
		status: libraries.name_folder_modal.status,
		message: libraries.name_folder_modal.message,
		//todo: delete hasParentFolder
		hasParentFolder: libraries.current.parents && libraries.current.parents.length>0,
		isSubfolder: libraries.current.parents && libraries.current.parents.length>1,
	})
)

export default nameFolderViewSelector
